module.exports = __webpack_public_path__ + "media/images/lb/491-e4a41474230af9bc13a4f7eccbf47ba3.svg";